import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { authApiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
export const deleteRole = async (roleId) => {
  await authApiClient.delete(`/roles/${roleId}`);
};

export const useDeleteRoleHandler = ({ onSuccess } = {}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: deleteRole,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['auth-roles'] });
      dispatch(
        showSnackbar({
          message: 'Role deleted successfully',
          severity: 'success',
        }),
      );
      onSuccess?.();
    },
    onError: (error) => {
      const message =
        error instanceof AxiosError
          ? error.response?.data?.errors?.message || error.message
          : 'Failed to delete role';
      dispatch(showSnackbar({ message, severity: 'error' }));
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
  };
};
